import {ActionTypes} from '../types/actionTypes';
import {Action} from '../typescript/actionTypes';
import {StoreTsCodes} from '../typescript/storeTypes';
import {InitialState} from './initialState';

export default function (state: StoreTsCodes = InitialState.mostRecentTsCodes, action: Action): StoreTsCodes {
    switch (action.type) {
        case ActionTypes.MOST_RECENT_TSCODES_SUCCEEDED: {
            return (action.payload as StoreTsCodes);
        }
        default: {
            return state;
        }
    }
}
